module.exports = __webpack_public_path__ + "static/media/sf_400_gray.fae24d7342463be215f1886a61b9b6cb.png";